import React from "react";
import axios from 'axios';

export const axiosQQUtility = axios.create({
	baseURL: process.env.REACT_APP_API_QUICKQUOTE_URL,
	timeout: 120000,
	headers: { 'Content-Type': 'application/json', 'Authorization' : 'Basic Z01GMkx0amJZUDVGNTVuUnBVdzUrU09hWktTZTNhc1Y6UFFRZE1oaG5wTHUvS2wwMzNUUHNhT25heEZpRW14YXo=' }
});

export const axiosUtilUtility = axios.create({
	baseURL: process.env.REACT_APP_API_UTIL_URL,
	timeout: 120000,
	headers: { 'Content-Type': 'application/json', 'authorization' : 'Basic Z01GMkx0amJZUDVGNTVuUnBVdzUrU09hWktTZTNhc1Y6UFFRZE1oaG5wTHUvS2wwMzNUUHNhT25heEZpRW14YXo=' }
});

export const axiosAppFormUtility = axios.create({
	baseURL: process.env.REACT_APP_BLUE_CHIP_URL,
	timeout: 120000,
	headers: { 'Content-Type': 'application/json', 'authorization' : 'Basic Z01GMkx0amJZUDVGNTVuUnBVdzUrU09hWktTZTNhc1Y6UFFRZE1oaG5wTHUvS2wwMzNUUHNhT25heEZpRW14YXo=' }
	
});

export const axiosCKYCUtility = axios.create({
	baseURL: process.env.REACT_APP_API_CKYC_URL,
	timeout: 120000,
	headers: { 'Content-Type': 'application/json', 'authorization' : 'Basic Z01GMkx0amJZUDVGNTVuUnBVdzUrU09hWktTZTNhc1Y6UFFRZE1oaG5wTHUvS2wwMzNUUHNhT25heEZpRW14YXo=' }
});

export const axiosDropOffUtility = axios.create({
	baseURL: process.env.REACT_APP_API_DROPOFF_URL,
	timeout: 120000,
	headers: { 'Content-Type': 'application/json', 'Authorization' : 'Basic Z01GMkx0amJZUDVGNTVuUnBVdzUrU09hWktTZTNhc1Y6UFFRZE1oaG5wTHUvS2wwMzNUUHNhT25heEZpRW14YXo=' }
});

export const axiosIFSCUtility = axios.create({
	baseURL: process.env.REACT_APP_API_IFSC_URL,
	timeout: 120000,
	headers: { 'Content-Type': 'application/json', 'Authorization' : 'Basic Z01GMkx0amJZUDVGNTVuUnBVdzUrU09hWktTZTNhc1Y6UFFRZE1oaG5wTHUvS2wwMzNUUHNhT25heEZpRW14YXo=' }
});

export const axiosQUOTEPREMUtility = axios.create({
  baseURL: process.env.REACT_APP_API_QUOTEPREM_URL,
	timeout: 120000,
  responseType: "blob",
  headers: {
    "Content-Type": "application/json",
    Authorization:
      "Basic Z01GMkx0amJZUDVGNTVuUnBVdzUrU09hWktTZTNhc1Y6UFFRZE1oaG5wTHUvS2wwMzNUUHNhT25heEZpRW14YXo=",
  }
});

export const axiosUploadUtility = axios.create({
	baseURL: process.env.REACT_APP_API_UPLOAD_URL,
	timeout: 150000,
	headers: { 'Content-Type': 'application/json'}, 'Authorization' : 'Basic Z01GMkx0amJZUDVGNTVuUnBVdzUrU09hWktTZTNhc1Y6UFFRZE1oaG5wTHUvS2wwMzNUUHNhT25heEZpRW14YXo='
});

export const axiosSellOnilneUtility = axios.create({
	baseURL: process.env.REACT_APP_API_SELL_ONLINE,
	timeout: 150000,
	headers: { 'Content-Type': 'application/json'}, 'Authorization' : 'Basic Z01GMkx0amJZUDVGNTVuUnBVdzUrU09hWktTZTNhc1Y6UFFRZE1oaG5wTHUvS2wwMzNUUHNhT25heEZpRW14YXo='
});

export const axiosSellOnilneUtilityValidate = axios.create({
	baseURL: process.env.REACT_APP_API_SELL_ONLINE,
	timeout: 150000,
	headers: { 'Content-Type': 'application/json' , 'Action-Type':'VALIDATE'}, 'Authorization' : 'Basic Z01GMkx0amJZUDVGNTVuUnBVdzUrU09hWktTZTNhc1Y6UFFRZE1oaG5wTHUvS2wwMzNUUHNhT25heEZpRW14YXo='
});

export const axiosPanCardUtility = axios.create({
	baseURL: process.env.REACT_APP_API_PAN_VERIFICATION,
	timeout: 150000,
	headers: { 'Content-Type': 'application/json'}, 'Authorization' : 'Basic Z01GMkx0amJZUDVGNTVuUnBVdzUrU09hWktTZTNhc1Y6UFFRZE1oaG5wTHUvS2wwMzNUUHNhT25heEZpRW14YXo='
});

export const axiosLeadInfoUtility = axios.create({
	baseURL: process.env.REACT_APP_YESBANK_URL,
	timeout: 120000,
	headers: { 'Content-Type': 'application/json', 'authorization' : 'Basic Z01GMkx0amJZUDVGNTVuUnBVdzUrU09hWktTZTNhc1Y6UFFRZE1oaG5wTHUvS2wwMzNUUHNhT25heEZpRW14YXo=' }
});

export const axiosPincodeInfoUtility = axios.create({
	baseURL: process.env.REACT_APP_Base_Url,
	timeout: 120000,
	headers: { 'Content-Type': 'application/json', 'authorization' : 'Basic Z01GMkx0amJZUDVGNTVuUnBVdzUrU09hWktTZTNhc1Y6UFFRZE1oaG5wTHUvS2wwMzNUUHNhT25heEZpRW14YXo=' }
});